export default __webpack_public_path__ + "fb4310f07caa5d1d6320003feaa354d9.svg";